var map = {
	"./protective_gear1.png": "./src/assets/images/protective_gear1.png",
	"./protective_gear2.png": "./src/assets/images/protective_gear2.png",
	"./protective_gear3.png": "./src/assets/images/protective_gear3.png",
	"./protective_gear4.png": "./src/assets/images/protective_gear4.png",
	"./protective_gear5.png": "./src/assets/images/protective_gear5.png",
	"./protective_gear6.png": "./src/assets/images/protective_gear6.png",
	"./protective_gear7.png": "./src/assets/images/protective_gear7.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/protective_gear.*\\.png$";